import { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import Loader, { showLoader } from "../components/loader";
import { apiUrl } from "../utils/url";
import { useDispatch, useSelector } from "react-redux";

const GoogleCallback = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const projectIntegrations = useSelector(state => state.projectIntegrationsReducer);
    const params = new URLSearchParams(window.location.search);
    const code = params?.get("code");
    
    const sendRequest = () => {

        const formData = new FormData();

        // for (const key in values) {
        //     if (Object.hasOwnProperty.call(values, key)) {
        //         formData.append(key, values[key]);
        //     }
        // }
        formData.append("code", code);
        formData.append("project", localStorage?.slug);
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formData,
            redirect: 'follow'
        };
        fetch(apiUrl + `/google/callback`, requestOptions)
            .then(async (res) => {
                const response = await res?.json();
                if (response?.status_code == 200) {
                    if (localStorage.google_sheets) {
                        dispatch({ type: 'SET_PROJECT_INTEGRATIONS', payload: {...projectIntegrations, google_sheets:true}})
                    }
                    toast.success(response?.status_message);
                } else {
                    toast.error(response?.status_message);
                }
                history.push({
                    pathname:localStorage.last_activity,
                    state:{
                        defaultPage: 'integrations'
                    }
                })
            })
            .catch((err) => {
                toast.error(err);
                history.push({
                    pathname:localStorage.last_activity,
                    state:{
                        defaultPage: 'integrations'
                    }
                })
            })
    }

    useEffect(() => {
        showLoader()
        if (code && localStorage?.slug) {
            sendRequest()
        }
    }, [code])
    return <Loader />
}
export default GoogleCallback